declare var require: any
import { Component, OnInit, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { CircularRequestComponent } from '../circular-request/circular-request.component';
import { CircularsFixedRebateOptions } from 'src/app/shared/models/circular.model';
import { CircularService } from 'src/app/shared/services/circular.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { Percentages, PercentageKey , StepDecision} from 'src/app/shared/models/circular.model';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { ErrorsEnum, ServiceStatus, FormMode,Logo, SCAWaterMark } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { DatePipe } from '@angular/common';

import * as pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from "pdfmake/build/vfs_fonts";
import { style } from '@angular/animations';
//import { element } from 'protractor';
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

@Component({
  selector: 'app-circular-request-requestor-decision',
  templateUrl: './Circular-request-requestor-decision.component.html'
})

export class CircularRequestRequestorDecisionComponent implements OnInit {
  private rebateRequestId: string = "";
  //@ViewChild('pdfTable') pdfTable: ElementRef;
  @ViewChild('pdfTable',{static: false}) pdfTable: ElementRef;
  @ViewChild('circularsRequest',{static: false}) circularsRequest: CircularRequestComponent;
  public circularOptions: CircularsFixedRebateOptions[] = [];
  private getRequestRequestorDecisionResponseObject: ResponseObject = new ResponseObject();
  private currentSelectedOption: string = "";
  addedOptions = [];
  private isOptionDetailsEnabled: boolean = false;
  private isOptionsNotValid: boolean = false;
  private isFormSubmitted: boolean = false;
  private isDecisionSelectionNotValid: boolean = false;
  private notesText: string = "";
  private isNotesEnabled: boolean = false;
  public Percentages: Percentages[] = [];
  public ports: Port[] = [];
  public currentUser: User = new User();
  public DecisionDTO: StepDecision = new StepDecision();
  private submitRequestorDecisionResponseObject: ResponseObject = new ResponseObject();

  public isRequestSucceeded: boolean = false;
  private isFormValid: boolean = true;
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 2;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  private showPDF: boolean = false;
  private show: boolean = false;
  private OriginsArr: PercentageKey[] = [];
  private selectedCircularsOption: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private previouslySelectedOption: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private DestinationsArr: PercentageKey[] = [];
  private isAccept: boolean = false;
  private isReject: boolean = false;
  private getSubmittedRebateRequestRequestorDecisionResponseObject: ResponseObject = new ResponseObject();
  @Output() rebateRequestRequestorDecisionLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  public isRequestDetailsComponent: boolean = false;
  private DecisionForm: FormGroup;
  private isSubmitEnabled: boolean = false;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  private isRequestExpired: boolean = false;
  private isRequestClosed: boolean = false;
  private StepName: string;
  private RequestStatus: number;

  constructor(private lookupService: LookupService, private circularService: CircularService, private router: Router,private alertService: AlertService, private formBuilder: FormBuilder, public datepipe: DatePipe, private globalServices: GlobalServices, private route: Router, private authenticationService: AuthenticationService) {
    this.globalServices.isLoaderEnabled = true;
    this.currentUser = this.authenticationService.currentUserValue;
    let currentUrl: string = window.location.href;
    let lastPartUrl: string = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
    if (lastPartUrl === "RequestDetails")
      this.isRequestDetailsComponent = true;
    if (lastPartUrl === "RequestorDecision")
      this.show = true;
  }
  setDefaults(): void {
    this.buildDecisionForm();
  }
  ngOnInit() {
    this.loadPorts();
    this.StepName = this.router.url;
    this.setDefaults();
    this.globalServices.isLoaderEnabled = true;

  }
  loadPorts(): void {

    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong!!"),
      //() => this.loadPortsCompleted()
    );
  }
  buildDecisionForm(): void {
    this.DecisionForm = this.formBuilder.group({
      ActionType: ['',[Validators.required]],
      RejectionReason: ['']
    });
  }
  onDecisionChange(): void {
    this.isFormSubmitted = false;
    this.isSubmitEnabled = true;
    switch (this.DecisionForm.controls['ActionType'].value) {
      case Decision.Accept:
        this.onAcceptDecision();
        break;
      case Decision.Reject:
        this.onRejectDecision();
        break;
      default:
        break;
    }
  }
  onAcceptDecision(): void {
    this.isReject = false;
    this.isSubmitEnabled = true;
    this.DecisionForm.controls["RejectionReason"].reset();
    this.DecisionForm.controls["RejectionReason"].clearValidators();
    this.DecisionForm.controls["RejectionReason"].updateValueAndValidity();
    this.DecisionForm.updateValueAndValidity();
    this.isAccept = true;

  }
  onRejectDecision(): void {
    this.isAccept = false;
    this.isReject = true;
    this.DecisionForm.controls["RejectionReason"].setValidators([Validators.required]);
    this.DecisionForm.controls["RejectionReason"].updateValueAndValidity();
    this.DecisionForm.updateValueAndValidity();
    this.isSubmitEnabled = true;
  }
  onCircularsRequestLoadedFlag(flag: boolean) {
    if (flag) {
      this.globalServices.isLoaderEnabled = true;
      this.rebateRequestId = this.circularsRequest.rebateRequestLoaded.Id;
      this.Percentages = this.circularsRequest.FromRegions;
      this.circularOptions = this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions;
      this.circularsRequest.showOptionDev = false;
      this.circularsRequest.editModeAdmin = true;
      this.isRequestExpired = this.circularsRequest.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Expired ? true : false;
      this.isRequestClosed = this.circularsRequest.rebateRequestLoaded.BaseRequest.IsCompleted ? true : false;
      this.fillRegionsDictionary();
      //this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = false;
      this.globalServices.isLoaderEnabled = false;
      this.RequestStatus = this.circularsRequest.rebateRequestLoaded.ExternalStatusId;
      this.setFormMode();
    }
  }

  fillRegionsDictionary(): void {
    for (let i: number = 0; i < this.circularOptions.length; i++) {
      let originport = ""
      let distport = ""
      this.OriginsArr[i] = new PercentageKey();
      this.OriginsArr[i].Index = i;
      this.OriginsArr[i].Percentage = this.Percentages.filter(p => p.Id == this.circularOptions[i].CircularsPercentagesId)[0].PercentageValue + " %";
      originport = this.circularOptions[i].LastPortOriginId != -1 && this.circularOptions[i].LastPortOriginId != null ? this.ports.filter(c => c.Id == this.circularOptions[i].LastPortOriginId)[0].NameEN : this.circularOptions[i].OtherLastPortOrigin;
      this.OriginsArr[i].Text = originport + ' - '+ this.Percentages.filter(p => p.Id == this.circularOptions[i].CircularsPercentagesId)[0].CircularsRegions.NameEN;

      this.DestinationsArr[i] = new PercentageKey();
      this.DestinationsArr[i].Index = i;
       distport = this.circularOptions[i].FirstPortDestinationId != -1 && this.circularOptions[i].FirstPortDestinationId != null ? this.ports.filter(c => c.Id == this.circularOptions[i].FirstPortDestinationId)[0].NameEN : this.circularOptions[i].OtherFirstPortDestination;
      this.DestinationsArr[i].Text = distport+ ' - '+ this.Percentages.filter(p => p.Id == this.circularOptions[i].CircularsPercentagesId)[0].CircularsRegions1.NameEN;


    }
  }
  setFormMode(): void {
    if (history.state.data && history.state.data.isCompleted){
      this.formMode = FormMode.Readonly;
      this.isSubmitEnabled = false;
      this.patchValues();
      this.DecisionForm.disable();
    }
    else if(this.RequestStatus == ServiceStatus.Circulars_PendingRequestorApproval){
            this.formMode = FormMode.Add;
      this.isSubmitEnabled = true;
            this.DecisionForm.enable();
    }
    else{
      this.formMode = FormMode.Readonly;
      this.isSubmitEnabled = false;
     this.patchValues();
      this.DecisionForm.disable()
    }
    }

    patchValues(){
      if(this.circularsRequest.rebateRequestLoaded.hasRequestorDecision){
        if (this.circularsRequest.rebateRequestLoaded.RequestorDecisionRejectionReason != "" &&
          this.circularsRequest.rebateRequestLoaded.RequestorDecisionRejectionReason != null) {
            this.onRejectDecision();
            this.DecisionForm.patchValue({
              ActionType: Decision.Reject,
              RejectionReason: this.circularsRequest.rebateRequestLoaded.RequestorDecisionRejectionReason,
            });
        }
        else{
          this.DecisionForm.patchValue({
            ActionType: Decision.Accept,
          });
        }
        this.isSubmitEnabled = false;
      }
    }

  submit(): void {
    this.isFormSubmitted = true;
    if (this.DecisionForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalServices.isLoaderEnabled = true;
    this.DecisionDTO.ActivityInstanceID = this.circularsRequest.rebateRequestLoaded.ActivityInstanceID;;
    this.DecisionDTO.StepName = this .StepName;
    this.DecisionDTO.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.DecisionDTO.ActionType = this.DecisionForm.controls['ActionType'].value;
    this.DecisionDTO.SCID = "";
    this.DecisionDTO.CircularFixedRebateRequestId = this.rebateRequestId;
    switch (this.DecisionForm.controls['ActionType'].value) {
      case Decision.Accept:
        this.DecisionDTO.comment = ""
        this.DecisionDTO.CircularsFixedRebateOptionDecisionHistory = this.addedOptions
        break;
      case Decision.Reject:
        this.DecisionDTO.comment = this.DecisionForm.controls['RejectionReason'].value
        this.DecisionDTO.CircularsFixedRebateOptionDecisionHistory =   this.addedOptions;
        break;
      default:
        break;
    }
    if (this.rebateRequestId && this.rebateRequestId != "")
    this.submitRequestorDecision();
  }
  submitRequestorDecision(): void {
    this.circularService.SubmitRequestorDecision(this.DecisionDTO).subscribe(
      data => this.submitRequestorDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitDecisionCompleted()
    );
  }

  submitDecisionCompleted(): void {
    if (this.submitRequestorDecisionResponseObject.Success) {
      this.submitConfirmationMode = ConfirmationMode.Success;
    } else {
      //Enable Error / Warning
      if (this.submitRequestorDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.submitRequestorDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    this.isRequestSucceeded = true;
    this.globalServices.isLoaderEnabled = false;
  }


  later(): void {
    this.router.navigateByUrl('/myTasks');
  }
}

enum Decision {
  Accept = "1",
  Reject = "3",
}

// enum FormMode {
//   New = 1,
//   Details = 2,
// }

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
